import React from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import {Box, Card, CardActions, CardContent, CardHeader, Divider} from "@mui/material";
import {Link} from "react-router-dom";
import {makeStyles} from "@mui/styles";
import {theme} from '../../../../config/design/theme';
import Grid from "@mui/material/Grid2";

const useStyles = makeStyles(() => ({
    link: {
        fontSize: 14,
    },
    textTruncate: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        color:theme.palette.secondary.main,
        fontSize:17,
        margin:'5px 0 ',
    },
    card:{
       borderRadius:"16px !important",
        boxShadow:"none",
        "& hr":{
            borderColor:theme.palette.primary.main,
            borderWidth:1,
            margin:"0 20px"
        }
    },
    cardHeader: {
        paddingLeft: "20px !important",
        paddingRight: "20px !important",
        paddingBottom: 4,
        [theme.breakpoints.down('sm')]: {
            flexDirection:'column',
            alignItems:'flex-start !important',
            padding: "10px 20px 0 !important"
        },
        '& .MuiCardHeader-action': {
            marginTop: 0,
            marginRight: 0,
        },
    },
}));

const AppCard = ({
                     title,
                     titleStyle,
                     headerStyle,
                     contentStyle,
                     action,
                     actionStyle,
                     footer,
                     footerPosition,
                     footerStyle,
                     children,
                     className,
                     component,
                     to,
                     target,
                     ...rest
                 }) => {
    const classes = useStyles();
    return (
        <Box display='flex' flexDirection='column' {...rest} clone>
            <Card className={clsx(classes.card,className)} component={component} to={to} target={target}>
                {title || action ? (
                    <>
                        <CardHeader
                            className={classes.cardHeader}
                            style={{
                                ...headerStyle,
                            }}
                            title={
                                <Box
                                    display='flex'
                                    flexDirection='row'
                                    alignItems='center'
                                    justifyContent='space-between'>
                                    {typeof title === 'object' ? (
                                        title
                                    ) : (
                                        <Box
                                            component='h3'
                                            className={classes.textTruncate}
                                            color='secondary'
                                            alignSelf='flex-start'
                                            fontWeight={700}
                                            fontSize={16}
                                            {...titleStyle}>
                                            {title}
                                        </Box>
                                    )}
                                </Box>
                            }
                            action={
                                typeof action === 'object' ? (

                                    <Box component='span' ml='auto' mt={4} mr={2} {...actionStyle}>
                                        {action}
                                    </Box>
                                ) : (
                                    <Box component='span' ml='auto' mt={4} mr={2} {...actionStyle}>
                                        <Link
                                            href='#'
                                            color='secondary'
                                            component='button'
                                            underline='none'
                                            className={classes.link}>
                                            <Box component='span'>{action}</Box>
                                        </Link>
                                    </Box>
                                )
                            }
                        />
                        <Divider />
                    </>

                ) : null}
                <CardContent
                    style={{
                        paddingLeft: 20,
                        paddingRight: 20,
                        height: '100%',
                        ...contentStyle,
                    }}>
                    {children}
                </CardContent>
                {footer ? (
                    <CardActions
                        style={{
                            paddingLeft: 20,
                            paddingRight: 20,
                            paddingBottom: 16,
                            ...footerStyle,
                        }}>
                        {typeof footer === 'object' ? (
                            footer
                        ) : (
                            <Box
                                component='span'
                                ml={footerPosition === 'right' ? 'auto' : 0}>
                                <Link
                                    color='secondary'
                                    component='button'
                                    underline='none'
                                    className={classes.link}>
                                    {footer}
                                </Link>
                            </Box>
                        )}
                    </CardActions>
                ) : null}
            </Card>
        </Box>
    );
};

export default AppCard;

AppCard.prototype = {
    action: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

AppCard.defaultProps = {
    footerPosition: 'left',
};
